import React from 'react'
import { Avatar, Chip, Grid } from '@mui/material'
import useDispatchRelatedState from '~/features/Dispatch/stores/DispatchRelatedState'
import useSystemState from '~/features/System/stores/SystemState'
import { useLang } from '~/hooks/useLang'
import RefreshIcon from '@mui/icons-material/Refresh'

interface DispatchRelatedListProps {
  readonly successSync: boolean
  readonly error?: string | null
  readonly handleClickOpen: (value: string) => void
  readonly onRetry: () => void
}

export default function DispatchRelatedList({ 
  successSync, 
  error,
  handleClickOpen,
  onRetry,
}: DispatchRelatedListProps) {
  const { translate } = useLang()
  const { getStatusColors } = useSystemState()
  const {
    dispatchRelated,
  } = useDispatchRelatedState()
  
  const itemsCount = dispatchRelated().keys.length
  const shouldApplyPadding = itemsCount > 10
  
  return (
    <Grid
      container
      width={'100%'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      gap={1}
      paddingTop={shouldApplyPadding ? 20 : 0}
      paddingBottom={shouldApplyPadding ? 5 : 0}
    >
      {
        successSync ? (
          dispatchRelated().keys.map((key) => {
            return (
              <Grid item key={dispatchRelated()[key].code.get()}>
                <Chip
                  label={dispatchRelated()[key].code.get()}
                  onClick={() =>
                    handleClickOpen(dispatchRelated()[key].code.get())
                  }
                  sx={{
                    backgroundColor: getStatusColors(
                      dispatchRelated()[key].status.id.get()
                    ).main,
                    color: getStatusColors(
                      dispatchRelated()[key].status.id.get()
                    ).contrastText,
                    '&:hover': {
                      backgroundColor: getStatusColors(
                        dispatchRelated()[key].status.id.get()
                      ).dark,
                      color: getStatusColors(
                        dispatchRelated()[key].status.id.get()
                      ).contrastText,
                    },
                  }}
                />
              </Grid>
            )
          })
        ) : (
          <Chip
            sx={{ marginTop: '25%' }}
            label={error || translate('Connection failed! Please try again')}
            avatar={
              <Avatar>
                <RefreshIcon />
              </Avatar>
            }
            onClick={onRetry}
          />
        )}
    </Grid>
  )
}